import React from 'react';

export default function Heading({
  submittedOnYourBehalf,
}: {
  submittedOnYourBehalf: boolean;
}): React.JSX.Element {
  return (
    <div className='md:flex mb-5'>
      <div className='md:w-full my-2'>
        <p className='confirmation-page-heading'>Payable Organization</p>
        <p className='text-base font-normal leading-6 mb-2'>
          {submittedOnYourBehalf
            ? 'Your organization has submitted KYC on your behalf.'
            : "Please confirm your organization's information below."}
        </p>
      </div>
    </div>
  );
}
